import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.scss';
import '../../resources/main.scss';
import { loginService } from "../../services/LoginService";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [userInitials, setUserInitials] = useState('MT');
    const [userName, setUserName] = useState('user');

    useEffect(() => {
        const userProfile = localStorage.getItem('userProfile');
        if (userProfile) {
            try {
                const profile = JSON.parse(userProfile);
                const isSupplierPage = (
                    location.pathname.startsWith('/produse-ofertare/')
                    || location.pathname.startsWith('/produse-ascunse/')
                    || location.pathname.startsWith('/oferte-inregistrate/')
                    || location.pathname === '/fara-oferte'
                );
                const supplierName = profile.supplier_name || profile.supplier?.name;
                const email = profile.email || profile.user?.email;

                const name = (isSupplierPage && supplierName)
                    ? supplierName
                    : (email || profile.name || profile.username || 'User');
                setUserName(name);
                const initials = name
                    .split(' ')
                    .map(word => word[0])
                    .join('')
                    .toUpperCase()
                    .slice(0, 2);
                setUserInitials(initials || 'MT');
            } catch (e) {
                console.error('Error parsing user profile:', e);
            }
        }
    }, [location.pathname]);

    const handleLogout = () => {
        loginService.logout()
            .then(() => {
                localStorage.removeItem('userProfile');
                loginService.setToken(null); 
                toast.success('Te-ai delogat cu succes.');
                navigate('/login');
            })
            .catch((error) => {
                console.error('Logout failed:', error);
                toast.error('A apărut o eroare la delogare.');
            });
    };

    return (
        <>
            {/* Desktop Header */}
            <div className='standard header header--desktop'>
                <img src='/images/logo.png' alt='logo' className='header__logo' />
                <div className='header__right-side'>
                    <h4 className='header__greeting'> Salut, {userName}</h4>
                    <div className='header__divider' />
                    <div className='header__account-box' onClick={handleLogout}
                        style={{ cursor: 'pointer' }}>
                        <img src="/images/user.png" alt='user' />
                        <h5>Iesi din cont</h5>
                    </div>
                </div>
            </div>

            {/* Mobile Header */}
            <div className='standard header header--mobile'>
                <img src='/images/logo.png' alt='logo' className='header__logo' />
                <div className='header__mobile-right'>
                    <span className='header__greeting-mobile'>Salut,</span>
                    <div className='header__avatar'>
                        {userInitials}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
